export default __webpack_public_path__ + "static/media/headerImage-removebg-preview.beba1950.png";